(function () {
  const spMenu = document.querySelector("#spMenu");
  const spMenuBtn = document.querySelector("#menuBtn");
  // const spMenuOpenBtn = document.querySelector("#sp-menu-open-btn");
  // const spMenuCloseBtn = document.querySelector("#sp-menu-close-btn");

  /**
    Mobile menu, show/hide based on mobile menu state.

    Entering: "duration-200 ease-out"
      From: "opacity-0 scale-95"
      To: "opacity-100 scale-100"
    Leaving: "duration-100 ease-in"
      From: "opacity-100 scale-100"
      To: "opacity-0 scale-95"
   */

  const showMobileMenu = () => {
    spMenuBtn.classList.add("opened");
    spMenu.classList.add("tw-duration-200 tw-ease-out".split(" "));
    spMenu.classList.remove("tw-hidden");
    spMenu.animate(
      [
        { opacity: 0, transform: "scale(.95)" },
        { opacity: 1, transform: "scale(1)" },
      ],
      {
        easing: "ease-out",
        duration: 200,
      }
    );
  };
  const closeMobileMenu = () => {
    spMenuBtn.classList.remove("opened");

    spMenu.animate(
      [
        { opacity: 1, transform: "scale(1)" },
        { opacity: 0, transform: "scale(.95)" },
      ],
      {
        duration: 100,
        easing: "ease-in",
      }
    );
    setTimeout(() => {
      spMenu.classList.add("tw-hidden");
    }, 100);
  };

  spMenuBtn.addEventListener("click", () => {
    spMenuBtn.classList.contains("opened")
      ? closeMobileMenu()
      : showMobileMenu();
  });
})();
